const actionTypes = { SET_BUY_PAGE: 'SET_BUY_PAGE' };

module.exports = actionTypes;
